export default __webpack_public_path__ + "da1f21c60c7217745dd8cc72766b84d8.svg";